import { RootState } from 'store';

export const selectAppModals = (state: RootState) => state.app.modals;
export const selectShowPatientCaseList = (state: RootState) => state.app.showPatientCaseList;
export const selectCurrentPatientTab = (state: RootState) => state.app.currentPatientTab;
export const selectAppIsLoading = (state: RootState) => state.app.appIsLoading;
export const selectModalsErrors = (state: RootState) => state.app.modalsErrors;
